// Set only after the hosted MCP/OAuth workflow is verified and the directory
// listing is published. No guessed installation URL or prelaunch CTA.
export function getResumeTailorListingUrl(value?: string): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || url.hostname !== "chatgpt.com" ||
        url.username || url.password || url.port || url.search || url.hash ||
        !/^\/plugins\/plugin_[a-zA-Z0-9_-]+\/?$/.test(url.pathname)) return null;
    return url.href;
  } catch { return null; }
}

export const RESUME_TAILOR_LISTING_URL = getResumeTailorListingUrl(
  process.env.NEXT_PUBLIC_RESUME_TAILOR_PLUGIN_URL
);
